import { atom } from 'jotai';

import {
  type IProvider,
  PROVIDERS,
  type ProviderId,
  getProviderById,
} from '@/providers';

export const providerIdAtom = atom<ProviderId>(PROVIDERS.NONE);

export const providerAtom = atom<IProvider>((get) => {
  const id = get(providerIdAtom);
  return getProviderById(id);
});
